export default "__VITE_ASSET__B_zO53$w__"